module.exports = __webpack_public_path__ + "static/media/facebook_logo.5d039139.svg";